/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Modal,
  Table,
  Button,
} from 'react-bootstrap';
import TablePager from 'loracoms/TablePager';
import ShowIf from 'loracoms/ShowIf';
import Checkbox from 'loracoms/Checkbox';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  disableCheck: PropTypes.array.isRequired,
};

class GatewayModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      checked: [],
      showModal: props.showModal,
      mark: 0,
      more: false,
      reset: 0,
    };
    this.intlMsg = new IntlMsg(props.intl, '');
    this.mark = 0;
  }

  componentWillMount() {
    this.loadGateways();
  }

  componentWillReceiveProps(nextProps) {
    const { showModal, disableCheck } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal, disableCheck });
      if (showModal) {
        this.loadGateways();
      }
    }
  }

  getStatus(gw) {
    const disconnected = (
      <span>
        <i className={`fa fa-circle-o ${styles.disconnected}`} />
        {' '}
        {this.intlMsg.msg('selectgateway.disconnected')}
      </span>
    );
    const connected = (
      <span>
        <i className={`fa fa-circle ${styles.connected}`} />
        {' '}
        {this.intlMsg.msg('selectgateway.connected')}
      </span>
    );

    if (_.isNil(gw.lastOn)) {
      return disconnected;
    }
    if (_.isNil(gw.lastOff)) {
      return connected;
    }
    const onts = new Date(gw.lastOn).valueOf();
    const offts = new Date(gw.lastOff).valueOf();
    if (onts > offts) {
      return connected;
    }
    return disconnected;
  }

  loadGateways() {
    this.setState({ status: 'loading' });
    callAPI({
      endpoint: '/lora/gateways',
      query: {
        mark: this.mark,
        sort: '-lastOn',
      },
    }).then((res) => {
      this.setState({
        list: res.list,
        more: res.more,
        mark: res.mark,
        status: 'success',
      });
    }).catch(() => {});
  }

  allChecked() {
    const { list, checked } = this.state;
    return (
      list.length > 0 &&
      list.length === checked.length
    );
  }

  handleToggleCheckAll() {
    this.setState({
      checked: this.allChecked() ? [] : this.state.list,
    });
  }

  isChecked(d) {
    return _.some(this.state.checked, { id: d.id });
  }

  isDisabled(d) {
    return _.some(this.state.disableCheck, { id: d.id });
  }

  toggleCheck(d) {
    const checked = this.state.checked;
    if (this.isChecked(d)) {
      this.setState({
        checked: _.filter(checked, a => a.id !== d.id),
      });
    } else {
      checked.push(d);
      this.setState({ checked });
    }
  }

  handlePrevPage(mark) {
    this.mark = mark;
    this.loadGateways();
  }

  handleNextPage(mark) {
    this.mark = mark;
    this.loadGateways();
  }

  handleAdd() {
    const { checked } = this.state;
    this.props.onSuccess(checked);
    this.setState({ reset: new Date(), checked: [], mark: 0 });
    this.mark = 0;
  }

  render() {
    const { showModal, list, mark, more, reset, status } = this.state;
    const { onHide } = this.props;
    const rows = _.map(list, item => (
      <tr key={item.id}>
        <td className={styles.checkbox}>
          <Checkbox
            id={item.id}
            checked={this.isChecked(item)}
            onChange={() => this.toggleCheck(item)}
            disabled={this.isDisabled(item)}
          />
        </td>
        <td>{item.name}</td>
        <td>{item.mac}</td>
        <td>{this.getStatus(item)}</td>
      </tr>
    ));
    return (
      <Modal
        show={showModal}
        onHide={() => {
          this.setState({ checked: [] });
          onHide();
        }}
        bsClass="aisz-modal-light"
      >
        <Modal.Header closeButton >{this.intlMsg.msg('selectgateway.title')}</Modal.Header>
        <Modal.Body>
          <Table
            className="aisz-table-light"
            bordered
            responsive
          >
            <thead>
              <tr>
                <th className={styles.checkbox} />
                <th>{this.intlMsg.msg('selectgateway.name')}</th>
                <th>{this.intlMsg.msg('selectgateway.mac')}</th>
                <th>{this.intlMsg.msg('selectgateway.status')}</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
          <div className="clearfix">
            <Button
              bsStyle="aisz-success"
              onClick={() => this.handleAdd()}
            >
              {this.intlMsg.msg('selectgateway.confirm')}
            </Button>
          </div>
          <ShowIf if={list.length > 0}>
            <div className="pull-right">
              <TablePager
                status={status}
                mark={mark}
                more={more}
                reset={reset}
                onPrev={m => this.handlePrevPage(m)}
                onNext={m => this.handleNextPage(m)}
              />
            </div>
          </ShowIf>
        </Modal.Body>
      </Modal>
    );
  }
}

GatewayModal.propTypes = propTypes;

const mapDispatchToProps = {
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(GatewayModal));




// WEBPACK FOOTER //
// ./src/components/GatewayModal/index.jsx